import styled from 'styled-components';

export const Container = styled.section`
  background-color: #f4f1f9;
  padding: 5rem 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Title = styled.h2`
  color: #221D34;
  font-size: 2.2rem;
  margin-bottom: 3rem;
  text-align: center;
`;

export const ComparisonTable = styled.div`
  width: 100%;
  max-width: 900px;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
`;

export const TableHeader = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  background-color: #7e57c2;
  color: white;
  font-weight: bold;
  padding: 1.5rem 1rem;
`;

export const MethodsHeader = styled.div`
  font-size: 1.1rem;
`;

export const CoursesHeader = styled.div`
  font-size: 1.1rem;
  text-align: center;
`;

export const FluenciAHeader = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const FluenciALogo = styled.img`
  height: 25px;
`;

export const TableRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  padding: 1rem;
  background-color: #f9f7fd;
  border-bottom: 1px solid #e6e0f0;
  
  &:nth-child(odd) {
    background-color: #f4f1f9;
  }
  
  &:last-child {
    border-bottom: none;
  }
`;

export const MethodColumn = styled.div`
  color: #4a2a82;
  font-weight: 600;
`;

export const CourseColumn = styled.div`
  color: #4a2a82;
  text-align: center;
`;

export const FluenciAColumn = styled.div`
  color: #4a2a82;
  text-align: center;
  font-weight: 500;
`;

export const CheckIcon = styled.span`
  display: inline-block;
  color: #10B981;
  font-size: 1.5rem;
  font-weight: bold;
`;
